import Path from "../../services/paths";
import DemandPlannerVersionsActions from "../actions/demandPlannerVersionsActions";
import utils from "../common/utils";
import axios from "axios";

class DemandPlannerVersionMiddleware {
  static getDemandPlannerVersions(
    page,
    selectedForecast
  ) {
    let url = `${Path.GET_DEMAND_PLANNER_VERSIONS}?`;
    if (page) {
      url += `page=${page}&`;
    }
    
    if (selectedForecast===false) {
      url += `forecasted=${selectedForecast}&`;
    } else {
      url += `forecasted=true&`;
    }

    url = url.slice(0, -1);
    // console.log("URL", url);

    return dispatch => {
      dispatch(DemandPlannerVersionsActions.demandPlannerVersionRequest());

      utils
        .get_token()
        .then(token => {
          axios({
            method: "GET",
            url: url,
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`
            }
          })
            .then(res => {
              if (res.error) {
                // console.log("ERROR", res.error);
              } else {
                // console.log("SUCCESS", res);
                dispatch(DemandPlannerVersionsActions.demandPlannerVersionSuccessul(res));
              }
            })
            .catch(error => {
              // console.log("IN CATCH");
              dispatch(DemandPlannerVersionsActions.demandPlannerVersionFailed(error));
            });
        })
        .catch(error => {
          // console.log("IN CATCH");
          dispatch(DemandPlannerVersionsActions.demandPlannerVersionFailed(error));
        });
    };
  }
}

export default DemandPlannerVersionMiddleware;
